import { Link, useParams, useRouter } from '@tanstack/react-router';
import { Globe, ChevronDown } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuLabel, DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { useSites } from '@/hooks/use-sites';

export function SiteSwitcher() {
  const { data } = useSites();
  const params = useParams({ strict: false }) as { siteId?: string };
  const router = useRouter();
  const current = data?.sites.find((s) => s.id === params.siteId);

  void router;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 rounded-md border border-border bg-transparent px-3 py-1.5 text-sm font-medium hover:bg-bg-surface-2 hover:border-border-strong transition-colors">
          <Globe className="size-3.5" />
          {current ? (
            <>
              <span>{current.name}</span>
              <span className="text-text-muted">{current.domain}</span>
            </>
          ) : (
            <span className="text-text-muted">Select site</span>
          )}
          <ChevronDown className="size-3 text-text-muted" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[280px]">
        <DropdownMenuLabel>Sites</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {data?.sites.length ? (
          data.sites.map((s) => (
            <DropdownMenuItem key={s.id} asChild>
              <Link to="/sites/$siteId" params={{ siteId: s.id }} className="flex flex-col items-start">
                <span className="font-medium">{s.name}</span>
                <span className="text-xs text-text-muted font-mono">{s.domain}</span>
              </Link>
            </DropdownMenuItem>
          ))
        ) : (
          <div className="px-2 py-1.5 text-xs text-text-muted">No sites yet</div>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/sites" className="text-accent">View all sites →</Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
